import React from "react";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import InputText from "../../common/Input/InputText";
import InputOnlyNumber from "../../common/Input/InputOnlyNumber";

const AddUpdateModal = ({
  modalVisible,
  setModalVisible,
  selectedAction,
  clinicTestProfileFormData,
  handleAddOrUpdateTestProfile,
  clinicTestMasterByClinicId,
  handleSetClinicTestProfileFormData,
  categories,
  setInputError,
  testSampleType,
  testMethod,
}) => {
  return (
    <>
      <Modal
        centered
        show={modalVisible}
        onHide={() => setModalVisible(false)}
        size={"lg"}
      >
        <div className="modal-header">
          <h3 className="modal-title" id="exampleModalLabel">
            {selectedAction === "Update"
              ? "Update Clinic Test Profile"
              : "Add Clinic Test Profile"}
          </h3>
          <button
            type="button"
            className="btn-close"
            onClick={() => setModalVisible(false)}
          ></button>
        </div>
        <div className="modal-body">
          <form onSubmit={handleAddOrUpdateTestProfile}>
            <div className="row">
              <div className="col-xl-6">
                <InputText
                  name="profileName"
                  value={clinicTestProfileFormData.profileName}
                  onChange={(e) => handleSetClinicTestProfileFormData(e)}
                  placeholder="Profile Name"
                  label="Profile Name"
                  fieldName="profileName"
                  setInputTextError={setInputError}
                />
              </div>
              <div className="col-xl-6">
                <div className="form-group position-relative">
                  <label htmlFor="tests" className="col-form-label">
                    Test Name:
                  </label>
                  {clinicTestProfileFormData && (
                    <Select
                      isMulti
                      value={clinicTestProfileFormData.testList}
                      placeholder="Select Tests"
                      onChange={(selectedOptions, actionMeta) => {
                        if (
                          actionMeta.action === "remove-value" ||
                          actionMeta.action === "pop-value"
                        ) {
                          const removedTest = actionMeta.removedValue;

                          const confirmRemove = window.confirm(
                            `This Test might be used in other places. If you want to remove it, then all information associated with this will be reset. Are you sure you want to remove "${removedTest.label}"?`,
                          );

                          if (!confirmRemove) {
                            return;
                          }
                        }

                        handleSetClinicTestProfileFormData(
                          selectedOptions,
                          "tests",
                        );
                      }}
                      options={
                        clinicTestMasterByClinicId &&
                        clinicTestMasterByClinicId[0]?.tests?.map((item) => ({
                          value: item?._id,
                          label: item?.testName,
                        }))
                      }
                      style={{
                        lineHeight: "40px",
                        color: "#7e7e7e",
                        paddingLeft: " 15px",
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group position-relative">
                  <label htmlFor="tests" className="col-form-label">
                    Categories Name:
                  </label>
                  {clinicTestProfileFormData && (
                    <Select
                      value={{
                        value: clinicTestProfileFormData.category,
                        label: clinicTestProfileFormData.categoryName,
                      }}
                      placeholder="Select Tests"
                      onChange={(selectedOptions) =>
                        handleSetClinicTestProfileFormData(
                          selectedOptions,
                          "categories",
                        )
                      }
                      options={
                        categories &&
                        categories.map((item) => ({
                          value: item._id,
                          label: item?.categoryName,
                        }))
                      }
                      style={{
                        lineHeight: "40px",
                        color: "#7e7e7e",
                        paddingLeft: " 15px",
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group position-relative">
                  <label htmlFor="tests" className="col-form-label">
                    Sample Type:
                  </label>
                  {clinicTestProfileFormData && (
                    <Select
                      value={{
                        value: clinicTestProfileFormData.testSampleType,
                        label: clinicTestProfileFormData.testSampleTypeName,
                      }}
                      placeholder="Select Sample Type"
                      onChange={(selectedOptions) =>
                        handleSetClinicTestProfileFormData(
                          selectedOptions,
                          "testSampleType",
                        )
                      }
                      options={
                        testSampleType &&
                        testSampleType.map((item) => ({
                          value: item._id,
                          label: item?.name,
                        }))
                      }
                      style={{
                        lineHeight: "40px",
                        color: "#7e7e7e",
                        paddingLeft: " 15px",
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group position-relative">
                  <label htmlFor="tests" className="col-form-label">
                    Method Name:
                  </label>
                  {clinicTestProfileFormData && (
                    <Select
                      value={{
                        value: clinicTestProfileFormData.testMethod,
                        label: clinicTestProfileFormData.testMethodName,
                      }}
                      placeholder="Select Method Type"
                      onChange={(selectedOptions) =>
                        handleSetClinicTestProfileFormData(
                          selectedOptions,
                          "testMethod",
                        )
                      }
                      options={
                        testMethod &&
                        testMethod.map((item) => ({
                          value: item._id,
                          label: item?.name,
                        }))
                      }
                      style={{
                        lineHeight: "40px",
                        color: "#7e7e7e",
                        paddingLeft: " 15px",
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <InputOnlyNumber
                    name="pt_price"
                    value={clinicTestProfileFormData.pt_price}
                    onChange={(e) => handleSetClinicTestProfileFormData(e)}
                    placeholder="Patient Price"
                    label="Patient Price"
                    fieldName="pt_price"
                    setInputOnlyNumberError={setInputError}
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <InputOnlyNumber
                  name="clientPrice"
                  value={clinicTestProfileFormData.clientPrice}
                  onChange={(e) => handleSetClinicTestProfileFormData(e)}
                  placeholder="Client Price"
                  label="Client Price"
                  fieldName="clientPrice"
                  setInputOnlyNumberError={setInputError}
                />
              </div>
              <div className="col-xl-6">
                <InputOnlyNumber
                  name="tax"
                  value={clinicTestProfileFormData.tax}
                  onChange={(e) => handleSetClinicTestProfileFormData(e)}
                  placeholder="Tax"
                  label="Tax"
                  fieldName="Tax"
                  setInputOnlyNumberError={setInputError}
                />
              </div>
              <div className="col-xl-6">
                <div className="form-group">
                  <label htmlFor="status" className="col-form-label me-3">
                    Status:
                  </label>
                  <div className="d-flex justify-content-between align-items-center">
                    {["Active", "Inactive", "Deleted"].map((status) => (
                      <div className="form-check d-flex" key={status}>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="status"
                          id={status.toLowerCase()}
                          value={status}
                          checked={clinicTestProfileFormData.status === status}
                          onChange={(e) =>
                            handleSetClinicTestProfileFormData(e)
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={status.toLowerCase()}
                        >
                          {status}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setModalVisible(false)}
              >
                Close
              </button>
              <button type="submit" className="btn btn-success">
                {selectedAction === "Update" ? "Update" : "Save"}
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default AddUpdateModal;
